const projects = [
  {
    id: 1,
    title: "Arduino mikrokontrolör tabanlı çalışan sensörler ve makine öğrenimi ile balık kalitesinin hızlı belirleneceği tazelik belirleme kutusu geliştirilmesi",
    year: 2023,
    description: "Yükseköğretim Kurumları Tarafından Destekli Bilimsel Araştırma Projesi. Arduino tabanlı sensörler ve makine öğrenimi kullanarak balık tazelik seviyesinin hızlı belirlenmesi.",
    role: "Araştırmacı",
    status: "Devam Ediyor",
    type: "ULUSAL",
    period: "2023-2024",
    link: "https://unis.ahievran.edu.tr/proje-detay/2_D3KnCW_58/arduino-mikrokontrolor-tabanli-calisan-sensorler-ve-makine-ogrenimi-ile-balik-kalitesinin-hizli-belirlenecegi-tazelik-belirleme-kutusu-gelistirilmesi"
  },
  {
    id: 2,
    title: "Arduino Temelli Su Kalite Seviyesi Belirleme Cihazı Geliştirilmesi",
    year: 2022,
    description: "Yükseköğretim Kurumları Tarafından Destekli Bilimsel Araştırma Projesi. Arduino tabanlı su kalite ölçüm cihazı geliştirme projesi.",
    role: "Yürütücü",
    status: "Tamamlandı",
    type: "ULUSAL",
    period: "2022-2024",
    link: "https://unis.ahievran.edu.tr/proje-detay/2_D34nDm_58/arduino-temelli-su-kalite-seviyesi-belirleme-cihazi-gelistirilmesi"
  },
  {
    id: 3,
    title: "Elektronik bileşenler ile gıda kalite seviyesinin belirlenmesi",
    year: 2022,
    description: "Yükseköğretim Kurumları Tarafından Destekli Bilimsel Araştırma Projesi. Elektronik bileşenler kullanarak gıda kalite seviyesi tespiti.",
    role: "Araştırmacı",
    status: "Tamamlandı",
    type: "ULUSAL",
    period: "2022-2022",
    link: "https://unis.ahievran.edu.tr/proje-detay/2_D34nDW_36/elektronik-bilesenler-ile-gida-kalite-seviyesinin-belirlenmesi"
  },
  {
    id: 4,
    title: "IoT Sistemlerde Kullanılan WiFi, Bluetooth Modüllerin İncelenmesi",
    year: 2021,
    description: "Yükseköğretim Kurumları Tarafından Destekli Bilimsel Araştırma Projesi. IoT sistemlerde kullanılan kablosuz iletişim modüllerinin incelenmesi.",
    role: "Yürütücü",
    status: "Tamamlandı",
    type: "ULUSAL",
    period: "2021-2022",
    link: "https://unis.ahievran.edu.tr/proje-detay/2_D34nDG_20/iot-sistemlerde-kullanilan-wifi-bluetooth-modullerin-incelenmesi"
  },
  {
    id: 5,
    title: "Arduino Mikro Denetleyici ile Gıda Kaynaklı Bozucu Bakterilerin Koku Limitlerinin Belirlenmesi",
    year: 2021,
    description: "Yükseköğretim Kurumları Tarafından Destekli Bilimsel Araştırma Projesi. Arduino ile gıda kaynaklı bakterilerin koku limitlerinin tespiti.",
    role: "Araştırmacı",
    status: "Tamamlandı",
    type: "ULUSAL",
    period: "2021-2022",
    link: "https://unis.ahievran.edu.tr/proje-detay/2_D34nD0_97/arduino-mikro-denetleyici-ile-gida-kaynakli-bozucu-bakterilerin-koku-limitlerinin-belirlenmesi"
  },
  {
    id: 6,
    title: "Dumanla değil Arduino ile haberleşiyoruz",
    year: 2020,
    description: "TÜBA ve TÜBİTAK Destekli Proje. Arduino tabanlı iletişim sistemleri geliştirme projesi.",
    role: "Yürütücü",
    status: "Tamamlandı",
    type: "ULUSAL",
    period: "2020-2021",
    link: "https://unis.ahievran.edu.tr/proje-detay/2_CJWvE0_63/dumanla-degil-arduino-ile-haberlesiyoruz"
  },
  {
    id: 7,
    title: "Düşük Maliyetli Alıcılar Kullanarak Kablosuz IoT Aygıtların Fiziksel Katman Kimlik Tespiti",
    year: 2020,
    description: "TÜBİTAK 1001 Projesi. Düşük maliyetli alıcılar kullanarak IoT cihazların fiziksel katman kimlik tespiti.",
    role: "Araştırmacı",
    status: "Tamamlandı",
    type: "ULUSAL",
    period: "2020-2023",
    link: "https://unis.ahievran.edu.tr/proje-detay/2_CJWvDm_23/dusuk-maliyetli-alicilar-kullanarak-kablosuz-iot-aygitlarin-fiziksel-katman-kimlik-tespiti"
  }
];

export default projects;

